import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDropdownFlip]'
})
export class DropdownFlipDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @HostListener('mouseenter')
  checkPosition() {
    const menu = this.el.nativeElement.querySelector('.action-menu');
    if (menu) {
      // Clone invisibly for measurement
      const clone = menu.cloneNode(true) as HTMLElement;
      clone.style.visibility = 'hidden';
      clone.style.display = 'block';
      clone.style.position = 'absolute';
      clone.style.top = '0';
      clone.style.left = '0';

      document.body.appendChild(clone);
      const menuHeight = clone.offsetHeight;
      document.body.removeChild(clone);

      // Trigger position
      const triggerRect = this.el.nativeElement.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const spaceBelow = windowHeight - triggerRect.bottom;
      const spaceAbove = triggerRect.top;

      const buffer = 200; // require 20px clearance underneath

      // Flip if there isn't enough room below (including buffer)
      if (spaceBelow < menuHeight + buffer && spaceAbove > spaceBelow) {
        this.renderer.addClass(menu, 'open-up');
      } else {
        this.renderer.removeClass(menu, 'open-up');
      }
    }
  }


}
